import { Button } from 'antd';
import useConfirmPossibleDuplicate from './useConfirmPossibleDuplicate.hook';
import { StyledConfirmPossibleDuplicate } from './ConfirmPossibleDuplicate.styled';
import { Paragraph } from '@/shared/Typography';
export default function ConfirmPossibleDuplicate({ flowState, flowActions }) {
  const { state, actions } = useConfirmPossibleDuplicate({
    flowState,
    flowActions,
  });
  const isPlural = flowState.studentData.possibleDuplicates.length > 1;
  return (
    <StyledConfirmPossibleDuplicate>
      <div className="centered-form">
        <div className="buttons">
          <Paragraph className="bigger-text">
            There {isPlural ? 'are other students' : 'is a student'} already
            enrolled as{' '}
            <span className="teacher-name">
              "{flowState.studentData.firstName}{' '}
              {flowState.studentData.lastName}"
            </span>{' '}
            in this class.
          </Paragraph>
          <Paragraph className="bigger-text">
            {isPlural ? 'Are you any of these?' : 'Is this you?'}
          </Paragraph>
          <div className="candidates">
            {flowState.studentData.possibleDuplicates.map((student, index) => (
              <Button
                type="primary"
                key={student.ssoProviders[0].ssoId}
                size="large"
                onClick={() => actions.goToDuplicateLogin(student)}
              >
                Log in as {student.ssoProviders[0].ssoId}
              </Button>
            ))}
          </div>
          <Paragraph className="bigger-text">
            If you are not, talk to your teacher.
          </Paragraph>
          {/* <div className="confirm-creation">
            <Button size="large" onClick={actions.confirmUserCreationAndEnroll}>
              Create user as "{flowState.studentData.firstName}{' '}
              {flowState.studentData.lastName}" and enroll.
            </Button>
          </div> */}

          {/* <Paragraph className="bigger-text">
            If in doubt please ask your teacher.
          </Paragraph> */}
          <div className="center-button">
            <Button size="large" onClick={actions.goBack}>
              Go back
            </Button>
          </div>
        </div>
      </div>
    </StyledConfirmPossibleDuplicate>
  );
}
